import dateTool from "./dateTool.js";
import dayjs from 'dayjs'

/* 标准键盘布局
┌───┐   ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┬───┐ ┌───┬───┬───┐
│Esc│   │ F1│ F2│ F3│ F4│ │ F5│ F6│ F7│ F8│ │ F9│F10│F11│F12│ │P/S│S L│P/B│  ┌┐    ┌┐    ┌┐
└───┘   └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┴───┘ └───┴───┴───┘  └┘    └┘    └┘
┌───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───┬───────┐ ┌───┬───┬───┐ ┌───┬───┬───┬───┐
│~ `│! 1│@ 2│# 3│$ 4│% 5│^ 6│& 7│* 8│( 9│) 0│_ -│+ =│ BacSp │ │Ins│Hom│PUp│ │N L│ / │ * │ - │
├───┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─────┤ ├───┼───┼───┤ ├───┼───┼───┼───┤
│ Tab │ Q │ W │ E │ R │ T │ Y │ U │ I │ O │ P │{ [│} ]│ | \ │ │Del│End│PDn│ │ 7 │ 8 │ 9 │   │
├─────┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴┬──┴─────┤ └───┴───┴───┘ ├───┼───┼───┤ + │
│ Caps │ A │ S │ D │ F │ G │ H │ J │ K │ L │: ;│" '│ Enter  │               │ 4 │ 5 │ 6 │   │
├──────┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴─┬─┴────────┤     ┌───┐     ├───┼───┼───┼───┤
│ Shift  │ Z │ X │ C │ V │ B │ N │ M │< ,│> .│? /│  Shift   │     │ ↑ │     │ 1 │ 2 │ 3 │   │
├─────┬──┴─┬─┴──┬┴───┴───┴───┴───┴───┴──┬┴───┼───┴┬────┬────┤ ┌───┼───┼───┐ ├───┴───┼───┤ E││
│ Ctrl│    │Alt │         Space         │ Alt│    │    │Ctrl│ │ ← │ ↓ │ → │ │   0   │ . │←─┘│
└─────┴────┴────┴───────────────────────┴────┴────┴────┴────┘ └───┴───┴───┘ └───────┴───┴───┘
*/

/**
 * 生成x轴数据
 * @param {*} dateType 时间的类型
 * @param {*} startDate  开始时间
 * @param {*} endDate 结束时间
 * @param {*} isThree 判断是否是统计量添加页面
 */
function createXData(dateType, startDate, endDate, isThree) {
  if (typeof startDate == "string") {
    let newStart = startDate;
    startDate = newStart;
  }
  if (typeof endDate == "string") {
    let newEnd = endDate;
    endDate = newEnd;
  }
  startDate = new Date(startDate);
  endDate = new Date(endDate);
  let differ = endDate.getTime() - startDate.getTime();
  let sDate = new Date(dateTool.format(startDate, "yyyy-MM-dd" + " 00:00:00"));
  let xData = [];
  switch (dateType) {
    //按天查询--小时
    case "0":
    case "day": {
      //生成24小时
      for (let index = 0; index < 24; index++) {
        let thisDate = new Date(startDate);
        thisDate.setHours(index);
        xData.push({
          title: index + "时",
          value: thisDate.getTime(),
        });
      }
      break;
    }
    case "2":
    case "month": {
      // //生成这个月的天
      let thisDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth() + 1,
        0
      ); //当天数为0 js自动处理为上一月的最后一天
      let days = thisDate.getDate();
      for (let index = 0; index < days; index++) {
        let thisDate = new Date(startDate);
        thisDate.setDate(index + 1);
        xData.push({
          title: index + 1 + "日",
          value: thisDate.getTime(),
        });
      }
      break;
    }
    case "3": {
      if (isThree == true) {
        for (let i = 0; i <= differ; i += 3600 * 1000 * 24) {
          let differDate = new Date(sDate.getTime() + i);
          xData.push({
            time: dateTool.format(differDate, "yyyy-MM-dd"),
            // value: differDate.getTime(),
            value: null,
          });
        }
      } else {
        if (differ / (24 * 3600 * 1000) <= 3) {
          for (let i = 0; i <= differ; i += 3600 * 1000) {
            let differDate = new Date(startDate.getTime() + i);
            xData.push({
              title: dateTool.format(differDate, "dd日hh时"),
              value: differDate.getTime(),
            });
          }
        } else {
          let sDate = new Date(
            dateTool.format(startDate, "yyyy-MM-dd" + " 00:00:00")
          );
          for (let i = 0; i <= differ; i += 3600 * 1000 * 24) {
            let differDate = new Date(sDate.getTime() + i);
            xData.push({
              title: dateTool.format(differDate, "MM月dd日"),
              value: differDate.getTime(),
            });
          }
        }
      }

      break;
    }
    case "5":
    case "year": {
      if (isThree == true) {
        // let sDate = new Date(dateTool.format(startDate, "yyyy-MM-dd" + " 00:00:00"));
        for (let i = 0; i <= differ; i += 3600 * 1000 * 24) {
          let differDate = new Date(sDate.getTime() + i);
          xData.push({
            time: dateTool.format(differDate, "yyyy-MM"),
            // value: differDate.getTime(),
            value: null,
          });
        }
      } else {
        for (let index = 0; index < 12; index++) {
          let thisDate = new Date(startDate);
          thisDate.setMonth(index);
          xData.push({
            title: index + 1 + "月",
            value: thisDate.getTime(),
          });
        }
      }
      break;
    }
    default: {
      break;
    }
  }
  return xData;
}

/**
 * 生成新型x轴数据
 * @param {*} dateType 时间的类型
 * @param {*} startDate  开始时间
 * @param {*} endDate 结束时间
 * @param {*} isThree 判断是否是统计量添加页面
 */
function createXDataNew(dateType, startDate, endDate, isThree) {
  if (typeof startDate == "string") {
    let newStart = startDate;
    startDate = newStart;
  }
  if (typeof endDate == "string") {
    let newEnd = endDate;
    endDate = newEnd;
  }
  startDate = new Date(startDate);
  endDate = new Date(endDate);
  let differ = endDate.getTime() - startDate.getTime();
  let sDate = new Date(dateTool.format(startDate, "yyyy-MM-dd" + " 00:00:00"));
  let xData = [];
  switch (dateType) {
    //按天查询--小时
    case "day":
      {
        //生成24小时
        for (let index = 0; index < 24; index++) {
          let thisDate = new Date(startDate);
          thisDate.setHours(index);
          xData.push({
            title: index + "时",
            value: thisDate.getTime(),
          });
        }
      }

      break;
    case "month":
      {
        // //生成这个月的天
        let thisDate = new Date(
          startDate.getFullYear(),
          startDate.getMonth() + 1,
          0
        ); //当天数为0 js自动处理为上一月的最后一天
        let days = thisDate.getDate();
        for (let index = 0; index < days; index++) {
          let thisDate = new Date(startDate);
          thisDate.setDate(index + 1);
          xData.push({
            title: index + 1 + "日",
            value: thisDate.getTime(),
          });
        }
      }
      break;
    case "timeInterval":
      {
        if (isThree == true) {
          for (let i = 0; i <= differ; i += 3600 * 1000 * 24) {
            let differDate = new Date(sDate.getTime() + i);
            xData.push({
              time: dateTool.format(differDate, "yyyy-MM-dd"),
              // value: differDate.getTime(),
              value: "",
            });
          }
        } else {
          if (differ / (24 * 3600 * 1000) <= 3) {
            for (let i = 0; i <= differ; i += 3600 * 1000) {
              let differDate = new Date(startDate.getTime() + i);
              xData.push({
                title: dateTool.format(differDate, "dd日hh时"),
                value: differDate.getTime(),
              });
            }
          } else {
            let sDate = new Date(
              dateTool.format(startDate, "yyyy-MM-dd" + " 00:00:00")
            );
            for (let i = 0; i <= differ; i += 3600 * 1000 * 24) {
              let differDate = new Date(sDate.getTime() + i);
              xData.push({
                title: dateTool.format(differDate, "MM月dd日"),
                value: differDate.getTime(),
              });
            }
          }
        }
      }

      break;
    case "year": {
      if (isThree == true) {
        // let sDate = new Date(dateTool.format(startDate, "yyyy-MM-dd" + " 00:00:00"));
        for (let i = 0; i <= differ; i += 3600 * 1000 * 24) {
          let differDate = new Date(sDate.getTime() + i);
          xData.push({
            time: dateTool.format(differDate, "yyyy-MM"),
            // value: differDate.getTime(),
            value: "",
          });
        }
      } else {
        for (let index = 0; index < 12; index++) {
          let thisDate = new Date(startDate);
          thisDate.setMonth(index);
          xData.push({
            title: index + 1 + "月",
            value: thisDate.getTime(),
          });
        }
      }
      break;
    }
    default: {
      break;
    }
  }
  return xData;
}
/* 匹配电流的数据
 * @param {*} arr 后端返回的data
 * @param {*} xData x轴数据，由createXData方法生成
 * @param {*} measureNodes 选中的计量点id信息
 * @param {*} codes 查询的code代码
 * @param {*} arrType 数组类型 1：采集原始数据的data 2 ：统计时月 3：统计的天
 * @param {*} arrType 时间的类型
 */
function matchData(arr, xData, measureNodes, codes, arrType, dType, decimal) {
  if (typeof decimal == "undefined") {
    decimal = 2;
  }
  let data = [];
  //1.获取计量点的名称
  for (let index = 0; index < measureNodes.length; index++) {
    let obj = {
      xData: [], //x轴的数据
      title: "", //计量点名称
      tip: [],
      selected: {},
      data: [],
    };
    for (let j = 0; j < codes.length; j++) {
      let element = arr.find(
        (obj) =>
          obj.measureId == measureNodes[index].id &&
          obj.pointCode == codes[j].code
      );
      let xArr = [];
      let dataItem = [];
      let itemData = [];
      if (arrType == 1) {
        itemData = element ? element.data.data : [];
      } else if (arrType == 2) {
        itemData = element ? element.data : [];
      } else if (arrType == 3) {
        itemData = element ? element.data[0] : [];
      }
      //找到对应计量点id和代码的数据
      for (let k = 0; k < xData.length; k++) {
        let item = itemData.find(
          (obj) => strToDate(obj.time, dType).getTime() == xData[k].value
        );
        xArr.push(xData[k].title);
        dataItem.push(item ? item.value.toFixed(decimal) : "-");
      }

      if (obj.xData.length == 0) {
        obj.xData = xArr;
      }
      obj.data.push(dataItem);
      obj.selected[codes[j].title] = codes[j].show;
      obj.tip.push(codes[j].title);
    }
    obj.title = measureNodes[index].label;
    data.push(obj);
  }
  return data;
}

function getMaxMinValue(arr) {
  let max = "-";
  let min = "-";
  for (let index = 0; index < arr.length; index++) {
    if (arr[index] != "-") {
      if (max != "-") {
        max = max > arr[index] ? max : arr[index];
      } else {
        max = arr[index];
      }
      if (min != "-") {
        min = min > arr[index] ? arr[index] : min;
      } else {
        min = arr[index];
      }
    }
  }
  return {
    max: max,
    min: min,
  };
}

/**
 * 处理最大最小值
 * @param {*} nodes
 * @param {*} codes
 * @param {*} dateType
 */
function handleMaxMin(arr, nodes, codes, dateType, isType3, decimal, ratio) {
  if (typeof decimal == "undefined") {
    decimal = 2;
  }
  if (typeof ratio == "undefined") {
    ratio = 1;
  }
  let data = [];
  let index = 0;
  for (let i = 0; i < nodes.length; i++) {
    const element = nodes[i];
    for (let j = 0; j < codes.length; j++) {
      let item = {
        measureName: element.label, //计量点名称
        title: "",
        max: "-",
        maxTime: "-",
        min: "-",
        minTime: "-",
      };
      item.title = codes[j].title;
      let arrItem = arr[index];
      if (isType3) {
        if (
          arrItem.data.max != null &&
          Object.keys(arrItem.data.max).length !== 0
        ) {
          let objMax = arrItem.data.max;
          item.max = (objMax.value * ratio).toFixed(decimal);
          item.maxTime = getTimeByDateType(objMax.time, dateType);
        }
        if (
          arrItem.data.min != null &&
          Object.keys(arrItem.data.min).length !== 0
        ) {
          let objMin = arrItem.data.min;
          item.min = (objMin.value * ratio).toFixed(decimal);
          item.minTime = getTimeByDateType(objMin.time, dateType);
        }
        data.push(item);
        index++;
      } else {
          const objDataMax = arrItem.data[0]?.max;

          if (objDataMax) {
            item.max = (objDataMax.value * ratio).toFixed(decimal);
            item.maxTime = getTimeByDateType(objDataMax.time, dateType);
          }
          const objDataMin = arrItem.data[0]?.min;
          if (objDataMin) {
            item.min = (objDataMin.value * ratio).toFixed(decimal);
            item.minTime = getTimeByDateType(objDataMin.time, dateType);
          }
        data.push(item);
        index++;
      }
    }
  }
  return data;
}

/**
 * 根据时间类型转换时间
 * @param {*} dateType
 */
function getTimeByDateType(value, dateType) {
  switch (dateType) {
    case "h":
      return dateTool.format(new Date(value), "yyyy-MM-dd hh时");
    case "h1":
      return dateTool.format(new Date(value), "yyyy-MM-dd hh:mm:ss");
    case "d":
      return dateTool.format(new Date(value), "yyyy-MM-dd");
    case "m":
      return dateTool.format(new Date(value), "yyyy-MM-dd");
    case "y":
      return dateTool.format(new Date(value), "yyyy-MM-dd");
  }
}

/**
 * 根据选中的tab获取api类型
 * @param {*} activeName
 */
function getTabTypeForApi(activeName) {
  const measuring = [
    "current",
    "voltage",
    "power",
    "factor",
    "frequency",
    "imbalance",
    "currentSpeed",
    "pressure",
    "abcTemperature",
    "abcTemperature2",
    "humidity",
    "temperature",
    "tableCode",
    "smokeSensation",
    "load",
    "density",
    "concentration",
    "flowCode",
    "forwardFlow", 
    "reverseFlow"
  ];
  if (measuring.findIndex((obj) => obj === activeName) > -1) {
    return "measuring";
  } else {
    return "q";
  }
}

/**
 * 根据选中的tab获取code
 * @param {*} activeName
 * @param {*} connectionMode
 */
function setCodes(activeName, connectionMode) {
  let codes = [];
  switch (activeName) {
    case "current":
      // if (connectionMode.indexOf("三相三线") > -1) {
      //   codes = [
      //     {
      //       code: "261",
      //       num: 0,
      //       title: "Iab",
      //       show: true,
      //     },
      //     {
      //       code: "262",
      //       num: 0,
      //       title: "Ibc",
      //       show: true,
      //     },
      //     {
      //       code: "263",
      //       num: 0,
      //       title: "Ica",
      //       show: true,
      //     },
      //   ];
      // } else {
      codes = [
        {
          code: "207",
          num: 0,
          title: "A相",
          show: true,
        },
        {
          code: "208",
          num: 0,
          title: "B相",
          show: true,
        },
        {
          code: "209",
          num: 0,
          title: "C相",
          show: true,
        },
      ];
      // }
      break;
    case "voltage":
      if (connectionMode.indexOf("三相三线") > -1) {
        codes = [
          {
            code: "249",
            num: 0,
            title: "Uab",
            show: true,
          },
          {
            code: "250",
            num: 0,
            title: "Ubc",
            show: true,
          },
          {
            code: "251",
            num: 0,
            title: "Uca",
            show: true,
          },
        ];
      } else {
        codes = [
          {
            code: "201",
            num: 0,
            title: "A相",
            show: true,
          },
          {
            code: "202",
            num: 0,
            title: "B相",
            show: true,
          },
          {
            code: "203",
            num: 0,
            title: "C相",
            show: true,
          },
        ];
      }
      break;
    case "power":
      if (connectionMode.indexOf("三相三线") > -1) {
        codes = [
          {
            code: "211",
            num: 0,
            title: "总有功功率(kW)",
            show: true,
          },
          { code: "264", num: 0, title: "AB线有功功率(kW)", show: false },
          { code: "265", num: 0, title: "BC线有功功率(kW)", show: false },
          { code: "266", num: 0, title: "CA线有功功率(kW)", show: false },
          {
            code: "215",
            num: 0,
            title: "总无功功率(kVar)",
            show: true,
          },
          { code: "267", num: 0, title: "AB线无功功率(kVar)", show: false },
          { code: "268", num: 0, title: "BC线无功功率(kVar)", show: false },
          { code: "269", num: 0, title: "CA线无功功率(kVar)", show: false },
          {
            code: "223",
            num: 0,
            title: "总视在功率(kVA)",
            show: true,
          },
          { code: "270", num: 0, title: "AB线视在功率(kVA)", show: false },
          { code: "271", num: 0, title: "BC线视在功率(kVA)", show: false },
          { code: "272", num: 0, title: "CA线视在功率(kVA)", show: false },
        ];
      } else {
        codes = [
          {
            code: "211",
            num: 0,
            title: "总有功功率(kW)",
            show: true,
          },
          { code: "212", num: 0, title: "A相有功功率(kW)", show: false },
          { code: "213", num: 0, title: "B相有功功率(kW)", show: false },
          { code: "214", num: 0, title: "C相有功功率(kW)", show: false },
          {
            code: "215",
            num: 0,
            title: "总无功功率(kVar)",
            show: true,
          },
          { code: "216", num: 0, title: "A相无功功率(kVar)", show: false },
          { code: "217", num: 0, title: "B相无功功率(kVar)", show: false },
          { code: "218", num: 0, title: "C相无功功率(kVar)", show: false },
          {
            code: "223",
            num: 0,
            title: "总视在功率(kVA)",
            show: true,
          },
          { code: "224", num: 0, title: "A相视在功率(kVA)", show: false },
          { code: "225", num: 0, title: "B相视在功率(kVA)", show: false },
          { code: "226", num: 0, title: "C相视在功率(kVA)", show: false },
        ];
      }
      break;
    case "factor":
      if (connectionMode.indexOf("三相三线") > -1) {
        codes = [
          {
            code: "219",
            num: 0,
            title: "总功率因数",
            show: true,
          },
          {
            code: "273",
            num: 0,
            title: "AB线功率因数",
            show: true,
          },
          {
            code: "274",
            num: 0,
            title: "BC线功率因数",
            show: true,
          },
          {
            code: "275",
            num: 0,
            title: "CA线功率因数",
            show: true,
          },
        ];
      } else {
        codes = [
          {
            code: "219",
            num: 0,
            title: "总功率因数",
            show: true,
          },
          {
            code: "220",
            num: 0,
            title: "A相功率因数",
            show: true,
          },
          {
            code: "221",
            num: 0,
            title: "B相功率因数",
            show: true,
          },
          {
            code: "222",
            num: 0,
            title: "C相功率因数",
            show: true,
          },
        ];
      }
      break;
    case "frequency":
      codes = [
        {
          code: "227",
          num: 0,
          title: "频率",
          show: true,
        },
      ];
      break;
    case "ele":
      codes = [
        {
          code: "100229",
          num: 0,
          title: "正向有功总电能(kWh)",
          show: true,
        },
      ];
      break;
    case "loadRate":
      codes = [
        {
          code: "233",
          num: 0,
          title: "负荷率",
          show: true,
        },
      ];
      break;
    case "imbalance":
      codes = [
        {
          code: "235",
          num: 0,
          title: "电压不平衡度",
          show: true,
        },
        {
          code: "242",
          num: 0,
          title: "电流不平衡度",
          show: true,
        },
      ];
      break;
    case "demand":
      codes = [
        {
          code: "228",
          num: 0,
          title: "需量",
          show: true,
        },
      ];
      break;
    case "forwardFlow":
      codes = [
        {
          code: "401",
          num: 0,
          title: "正向流量",
          show: true,
        },
      ];
      break;
    case "reverseFlow":
      codes = [
        {
          code: "402",
          num: 0,
          title: "反向流量",
          show: true,
        },
      ];
      break;
    case "currentSpeed":
      codes = [
        {
          code: "403",
          num: 0,
          title: "流速",
          show: true,
        },
      ];
      break;
    case "pressure":
      codes = [
        {
          code: "404",
          num: 0,
          title: "压力",
          show: true,
        },
      ];
      break;
    case "density":
      codes = [
        {
          code: "405",
          num: 0,
          title: "密度",
          show: true,
        },
      ];
      break;
    case "abcTemperature":
      codes = [
        {
          code: "501",
          num: 0,
          title: "A相温度",
          show: true,
        },
        {
          code: "501",
          num: 1,
          title: "B相温度",
          show: true,
        },
        {
          code: "501",
          num: 2,
          title: "C相温度",
          show: true,
        },
      ];
      break;
    case "abcTemperature2":
      codes = [
        {
          code: "501",
          num: 0,
          title: "A相温度",
          show: true,
        },
        {
          code: "501",
          num: 1,
          title: "B相温度",
          show: true,
        },
        {
          code: "501",
          num: 2,
          title: "C相温度",
          show: true,
        },
      ];
      break;
    case "temperature":
      codes = [
        {
          code: "501",
          num: 0,
          title: "温度",
          show: true,
        },
      ];
      break;
    case "humidity":
      codes = [
        {
          code: "502",
          num: 0,
          title: "湿度",
          show: true,
        },
      ];
      break;
    case "water":
      codes = [
        {
          code: "100401",
          num: 0,
          title: "总用量",
          show: true,
        },
      ];
      break;
    case "tableCode":
      codes = [
        {
          code: "229",
          num: 0,
          title: "表码",
          show: true,
        },
      ];
      break;
    case "smokeSensation":
      codes = [
        {
          code: "601",
          num: 0,
          title: "烟感",
          show: true,
        },
      ];
      break;
    case "load":
      codes = [
        {
          code: "234",
          num: 0,
          title: "负载率",
          show: true,
        },
      ];
      break;
    case "concentration":
      codes = [
        {
          code: "410",
          num: 0,
          title: "浓度",
          show: true,
        },
      ];
      break;
    case "flowCode":
      codes = [
        {
          code: "401",
          num: 0,
          title: "累计流量",
          //     title: "流量表码",
          show: true,
        },
      ];
      break;

    case "production":
      codes = [
        {
          code: "100701",
          num: 0,
          title: "产量",
          show: true,
        },
      ];
      break;
    case "consumption":
      codes = [
        {
          code: "1000",
          num: 2,
          title: "单耗",
          show: true,
        },
      ];
      break;
  }
  return codes;
}

function strToDate(date, dateType) {
  let time = null;
  if (dateType == "h") {
    time = dateTool.format(new Date(date), "yyyy-MM-dd hh") + ":00:00";
  } else if (dateType == "d") {
    time = dateTool.format(new Date(date), "yyyy-MM-dd") + " 00:00:00";
  } else if (dateType == "m") {
    time = dateTool.format(new Date(date), "yyyy-MM") + "/01 00:00:00";
  }
  return new Date(time);
}

/**
 * 处理频率的数据
 * @param {*} arr
 * @param {*} xData
 * @param {*} measureNodes
 */
function matchFrequencyData(arr, xData, measureNodes, dateType) {
  let data = [];
  let xArr = [];
  for (let index = 0; index < xData.length; index++) {
    xArr.push(xData[index].title);
  }
  //1.获取计量点的名称
  for (let index = 0; index < measureNodes.length; index++) {
    let obj = {
      xData: xArr, //x轴的数据
      title: "", //计量点名称
      tip: ["频率偏差"],
      selected: {
        // 最大频率: true,
        // 最小频率: true,
        频率偏差: true,
      },
      data: [],
    };
    let maxData = [];
    let minData = [];
    let differData = [];
    let element = arr[index];
    for (let k = 0; k < xData.length; k++) {
      let itemMax = element
        ? element.max.find((obj) => {
            return strToDate(obj.time, dateType).getTime() == xData[k].value;
          })
        : null;
      let max = itemMax ? itemMax.value.toFixed(2) : "-";
      maxData.push(max);

      let itemMin = element
        ? element.min.find((obj) => {
            return strToDate(obj.time, dateType).getTime() == xData[k].value;
          })
        : null;
      let min = itemMin ? itemMin.value.toFixed(2) : "-";
      minData.push(min);

      let differ = "-";
      // if (max == "-" && min == "-") { differ = "-" }
      // else if (max == "-") { differ = min }
      // else if (min == "-") { differ = max }
      // else { differ = (max - min).toFixed(2) }
      if (max == "-" && min == "-") {
        differ = "-";
      } else if (max == "-" && min !== "-") {
        differ = Math.abs(min - 50).toFixed(2);
      } else if (max !== "-" && min == "-") {
        differ = Math.abs(max - 50).toFixed(2);
      } else {
        differ =
          max - 50 > min - 50
            ? Math.abs(max - 50).toFixed(2)
            : Math.abs(min - 50).toFixed(2);
      }

      differData.push(differ);
    }
    obj.data.push(differData);

    obj.title = measureNodes[index].label;
    data.push(obj);
  }
  return data;
}

/**
 * 处理用电量的数据
 * @param {*} arr
 * @param {*} xData
 * @param {*} measureNodes
 */
function matchEleData(arr, xData, xDataLast, nodes, dateNames, isArr) {
  let eleData = [];
  for (let index = 0; index < nodes.length; index++) {
    const arrItem = arr[0].data[index];
    const arrItem2 = arr[1].data[index];
    const nodeName = nodes[index].label;
    let obj = {
      xData: [], //x轴的数据
      title: nodeName, //计量点名称
      tip: dateNames,
      selected: {},
      data: [],
      table: [],
    };

    let xArr = [];
    let todayYData = [];
    let yesterdayYData = [];
    let data = [];
    if (arrItem.data.length > 0) {
      data = isArr ? arrItem.data[0] : arrItem.data;
    }

    let maxMin = {
      measureName: nodeName,
      max: "-",
      maxTime: "-",
      min: "-",
      minTime: "-",
      title: dateNames[0],
    };
    for (let k = 0; k < xData.length; k++) {
      let item = null;
      if (data) {
        item = data.find(
          (obj) => new Date(obj.time).getTime() == xData[k].value
        );
      }
      if (item) {
        if (maxMin.max == "-") {
          maxMin.max = item.value ? item.value.toFixed(2) : "-";
          maxMin.maxTime = item.time;
          maxMin.min = item.value ? item.value.toFixed(2) : "-";
          maxMin.minTime = item.time;
        } else {
          if (maxMin.max < item.value) {
            maxMin.max = item.value.toFixed(2);
            maxMin.maxTime = item.time;
          }
          if (maxMin.min > item.value) {
            maxMin.min = item.value.toFixed(2);
            maxMin.minTime = item.time;
          }
        }
      }
      xArr.push(xData[k].title);
      todayYData.push(item ? item.value.toFixed(2) : "-");
    }
    obj.table.push(maxMin);
    maxMin = {
      measureName: nodeName,
      max: "-",
      maxTime: "-",
      min: "-",
      minTime: "-",
      title: dateNames[1],
    };
    obj.xData = xArr;
    obj.data.push(todayYData);

    if (arr.length > 1) {
      let data2 = [];
      if (arrItem2.data.length > 0) {
        data2 = isArr ? arrItem2.data[0] : arrItem2.data;
      }
      for (let k = 0; k < xDataLast.length; k++) {
        let item = null;
        if (data2) {
          item = data2.find(
            (obj) => new Date(obj.time).getTime() == xDataLast[k].value
          );
        }
        if (item) {
          if (maxMin.max == "-") {
            maxMin.max = item.value ? item.value.toFixed(2) : "-";
            maxMin.maxTime = item.time;
            maxMin.min = item.value ? item.value.toFixed(2) : "-";
            maxMin.minTime = item.time;
          } else {
            if (maxMin.max < item.value) {
              maxMin.max = item.value.toFixed(2);
              maxMin.maxTime = item.time;
            }
            if (maxMin.min > item.value) {
              maxMin.min = item.value.toFixed(2);
              maxMin.minTime = item.time;
            }
          }
        }
        yesterdayYData.push(item && item.value ? item.value.toFixed(2) : "-");
      }
      obj.table.push(maxMin);

      obj.data.push(yesterdayYData);
    }

    eleData.push(obj);
  }
  return eleData;
}
/**
 * 处理用电量的数据
 * @param {*} arr
 * @param {*} xData
 * @param {*} measureNodes
 */
function matchEleDataOther(arr, xData, nodes, dateNames, isArr) {
  let eleData = [];
  for (let index = 0; index < nodes.length; index++) {
    const arrItem = arr;
    // const arrItem2 = arr[1].data[index];
    const nodeName = nodes[index].label;
    let obj = {
      xData: [], //x轴的数据
      tip: dateNames,
      title: nodeName, //计量点名称
      selected: {},
      data: [],
    };

    let xArr = [];
    let todayYData = [];
    let data = [];

    data = isArr ? arrItem : arrItem;
    for (let k = 0; k < xData.length; k++) {
      let item = null;
      if (data) {
        item = data.find(
          (obj) => new Date(obj.time).getTime() == xData[k].value
        );
      }
      xArr.push(xData[k].title);
      todayYData.push(item ? item.avg.toFixed(2) : "-");
    }
    obj.xData = xArr;
    obj.data[0] = todayYData;
    eleData.push(obj);
  }
  return eleData;
}
/**
 * 处理采集间隔的数据
 * @param {*} arr
 * @param {*} nodes
 * @param {*} codes
 */
function matchMeasuringData(arr, nodes, codes, decimal, ratio) {
  if (typeof decimal == "undefined") {
    decimal = 2;
  }
  if (typeof ratio == "undefined") {
    ratio = 1;
  }
  let data = [];
  for (let i = 0; i < nodes.length; i++) {
    const nodeItem = nodes[i];
    let obj = {
      xData: [], //x轴的数据
      title: nodeItem.label, //计量点名称
      tip: [],
      selected: {},
      data: [],
    };

    for (let j = 0; j < codes.length; j++) {
      const codeItem = codes[j];
      let tipData = [];
      let xData = [];

      let measureItem = arr.find(
        (e) => e.measureId == nodeItem.id && e.pointCode == codeItem.code
      );

      if (measureItem) {
        for (let index = 0; index < measureItem.data.data.length; index++) {
          const dataItem = measureItem.data.data[index];
          xData.push(dataItem.time);
          tipData.push((dataItem.value * ratio).toFixed(decimal));
        }
      }
      if (xData.length > obj.xData.length) {
        obj.xData = xData;
      }
      obj.tip.push(codeItem.title);
      obj.selected[codeItem.title] = codeItem.show;
      obj.data.push(tipData);
    }
    data.push(obj);
  }
  return data;
}

function getQuantityMaxMin(data, codes, nodes, type, dateType) {
  let tableData = [];
  for (let i = 0; i < nodes.length; i++) {
    for (let j = 0; j < codes.length; j++) {
      let item = data.find(
        (obj) => obj.measureId == nodes[i].id && obj.pointCode == codes[j].code
      );
      let maxMin = {
        measureName: nodes[i].label,
        max: "-",
        maxTime: "-",
        min: "-",
        minTime: "-",
      };
      if (item) {
        let arr = type == "1" ? item.data : item.data[0];
        for (let k = 0; k < arr.length; k++) {
          if (maxMin.max == "-") {
            maxMin.max = arr[k].value ? arr[k].value.toFixed(2) : "-";
            maxMin.maxTime = dateTypeTitle(dateType, arr[k].time);
            maxMin.min = arr[k].value ? arr[k].value.toFixed(2) : "-";
            maxMin.minTime = dateTypeTitle(dateType, arr[k].time);
          } else {
            if (maxMin.max < arr[k].value) {
              maxMin.max = arr[k].value ? arr[k].value.toFixed(2) : "-";
              maxMin.maxTime = dateTypeTitle(dateType, arr[k].time);
            }
            if (maxMin.min > arr[k].value) {
              maxMin.min = arr[k].value ? arr[k].value.toFixed(2) : "-";
              maxMin.minTime = dateTypeTitle(dateType, arr[k].time);
            }
          }
        }
      }
      tableData.push(maxMin);
    }
  }
  return tableData;
}

function dateTypeTitle(dateType, date) {
  let dateTime = new Date(date);
  let str = "";
  switch (dateType) {
    case 1:
      str = dateTool.format(dateTime, "yyyy-MM-dd hh时");
      break;
    case 2:
      str = dateTool.format(dateTime, "yyyy-MM-dd");
      break;
    case 3:
      str = dateTool.format(dateTime, "yyyy-MM");
      break;
  }

  return str;
}

function findValue(data, measureId, code) {
  const item = data.find(
    (obj) => obj.measureId == measureId && obj.pointCode == code
  );
  if (item) {
    return item.value ? item.value.toFixed(2) : "-";
  } else {
    return "-";
  }
}

function tabData(expressionsData = []) {
  let expressions = [];
  for (let i = 0; i < expressionsData.length; i++) {
    const group = expressionsData[i];
    for (let j = 0; j < group.expression.length; j++) {
      expressions.push(group.expression[j]);
    }
  }
  const analysisTabData = {
    current: ["261", "262", "263", "207", "208", "209"],
    voltage: ["249", "250", "251", "201", "202", "203"],
    power: [
      "211",
      "264",
      "265",
      "266",
      "215",
      "267",
      "268",
      "269",
      "223",
      "270",
      "271",
      "272",
      "212",
      "213",
      "214",
      "216",
      "217",
      "218",
      "224",
      "225",
      "226",
    ],
    factor: ["219", "273", "274", "275", "219", "220", "221", "222"],
    frequency: ["227"],
    ele: ["100229"],
    loadRate: ["233"],
    imbalance: ["235", "242"],
    demand: ["228"],
    forwardFlow: ["401"],
    reverseFlow: ["402"],
    currentSpeed: ["403"],
    pressure: ["404"],
    density: ["405"],
    abcTemperature: ["501"],
    abcTemperature2: ["501"],
    temperature: ["501"],
    humidity: ["502"],
    water: ["100401"],
    tableCode: ["229"],
    smokeSensation: ["601"],
    load: ["234"],
    concentration: ["410"],
    production: ["100701"],
    consumption: ["1000"],
  };

  let tabData = [
    { label: "电压", value: "voltage" },
    { label: "电流", value: "current" },
    { label: "功率", value: "power" },
    { label: "功率因数", value: "factor" },
    { label: "频率", value: "frequency" },
    { label: "用电量", value: "ele" },
    { label: "负荷率", value: "loadRate" },
    { label: "不平衡度", value: "imbalance" },
    { label: "用量", value: "water" },
    { label: "正向流量", value: "forwardFlow" },
    { label: "反向流量", value: "reverseFlow" },
    { label: "密度", value: "density" },
    { label: "流速", value: "currentSpeed" },
    { label: "压力", value: "pressure" },
    { label: "绕组温度", value: "abcTemperature" },
    { label: "触头温度", value: "abcTemperature2" },
    { label: "温度", value: "temperature" },
    { label: "湿度", value: "humidity" },
    { label: "表码", value: "tableCode" },
    { label: "烟感", value: "smokeSensation" },
    { label: "负载率", value: "load" },
    { label: "浓度", value: "concentration" },
    { label: "产量", value: "production" },
    { label: "单耗", value: "consumption" },
    //   { label: "流量表码", value: "flowCode" },
  ];

  for (let key in analysisTabData) {
    let have = false;
    for (let i = 0; i < analysisTabData[key].length; i++) {
      const code = analysisTabData[key][i];
      const item = expressions.find((c) => c.pointCode == code);
      if (item) {
        have = true;
        break;
      }
    }
    if (!have) {
      const tabIndex = tabData.findIndex((c) => c.value == key);
      if (tabIndex > -1) {
        tabData.splice(tabIndex, 1);
      }
    }
  }
  return tabData;
}

function isSameTimeXData(dateType, time, xDataTitle) {
  const obj = {
    'year': 'month',
    'month': 'date',
    'day': 'hour'
  }
  let val = dayjs(time).get(obj[dateType]);
  if (dateType === 'year') {
    val++
  }
  return val === parseFloat(xDataTitle)
}

// 导出接口
export default {
  createXData,
  createXDataNew,
  matchData,
  handleMaxMin,
  setCodes,
  matchFrequencyData,
  matchEleData,
  matchMeasuringData,
  getQuantityMaxMin,
  findValue,
  getTabTypeForApi,
  matchEleDataOther,
  tabData,
  isSameTimeXData
};
